module.exports = __webpack_public_path__ + "img/contact.91fc4e6f.jpg";